import { useEffect, useState } from 'react';
import { Modal, Button, TextField, Toggle } from '@fabric-ds/react';

interface SaveSearchModalProps {
    isLoggedIn: boolean;
    isOpen: boolean;
    query?: string | null;
    saveSearch: (name: string, notify: boolean) => void;
    setOpen: (open: boolean) => void;
}

export const SaveSearchModal = ({ saveSearch, query, isOpen, setOpen, isLoggedIn }: SaveSearchModalProps) => {
    const createName = (theQuery) => `Feriehjem og hytter ${theQuery ? `- ${theQuery}` : ''}`;

    const [name, setName] = useState(createName(query));
    const [notify, setNotify] = useState(true);

    const handleSaveSearch = () => {
        saveSearch(name, notify);
        setName('');
        setNotify(true);
        setOpen(false);
    };

    useEffect(() => {
        setName(createName(query));
        setNotify(true);
    }, [query]);

    return isLoggedIn ? (
        <Modal
            open={isOpen}
            aria-label="Lagre søk"
            title="Lagre søk"
            right
            onDismiss={() => setOpen(false)}
            className="truncate"
            footer={
                <div className="grid grid-cols-2 truncate">
                    <Button link onClick={() => setOpen(false)}>
                        Avbryt
                    </Button>
                    <Button primary disabled={!name} onClick={handleSaveSearch}>
                        Lagre
                    </Button>
                </div>
            }>
            <TextField label="Navn" value={name} onChange={(e) => setName(e.target.value)} required />
            <Toggle
                className="my-16"
                type="checkbox"
                label="Ja takk, varsle meg om nye treff"
                checked={notify}
                onChange={(checked) => setNotify(checked)}
            />
            <div className="text-12">Du blir varslet på e-post.</div>
        </Modal>
    ) : (
        <Modal
            open={isOpen}
            aria-label="Lagre søk"
            title="Lagre søk"
            right
            onDismiss={() => setOpen(false)}
            footer={
                <>
                    <Button href="/auth/login" className="mr-16" data-testid="saveSearchNewUserButton">
                        Ny bruker
                    </Button>
                    <Button primary href="/auth/login" data-testid="saveSearchLoginButton">
                        Logg inn
                    </Button>
                </>
            }>
            <p>Du må logge inn for å lagre søket</p>
        </Modal>
    );
};
